var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForgot2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 854.134,
    height: 708,
    viewBox: "0 0 854.134 708",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00a4d6;opacity:0.037;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M854.134,52.525S712.64-74.15,565.357,65.945c-163.366,155.394-73.675,429.832-210.6,437.572S169.135,474.25,81.523,528.979C-20.188,592.515,2.061,708,2.061,708H854.134Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgot2);
export default __webpack_public_path__ + "static/media/forgot2.d41d2a56701ea0e5475679b7b822bbcb.svg";
export { ForwardRef as ReactComponent };